import { Order_Output as Order } from "@/api";
import SummaryCard from "@/components/SummaryCard";

interface OrderSummaryProps {
  orders: Array<Order>;
}

const OrderSummary = ({ orders }: OrderSummaryProps) => {
  const totalOrders = orders.length;
  const totalQuantity = orders.reduce((sum, order) => sum + (order.quantity || 0), 0);
  const uniqueSkus = new Set(orders.map((order) => order.sku_id)).size;
  const uniqueDestinations = new Set(orders.map((order) => order.destination)).size;

  return (
    <div className="tw-grid tw-grid-cols-4 tw-gap-4 py-4">
      <SummaryCard title="注文件数" target={totalOrders} className="flex-1/4" />
      <SummaryCard title="注文数量合計" target={totalQuantity} className="flex-1/4" />
      <SummaryCard title="注文品目数" target={uniqueSkus} className="flex-1/4" />
      <SummaryCard title="納入拠点数" target={uniqueDestinations} className="flex-1/4" />
    </div>
  );
};

export default OrderSummary;
